// extracted by mini-css-extract-plugin
module.exports = {"container":"Response_container__fMm27","icon":"Response_icon__unyB9","type_name":"Response_type_name__ivQnF"};